<!-- 文章栏目管理 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex">
        <div class="text">文章栏目管理</div>
        <el-button @click="addColumnBut" round type="primary" size="small"
          >新增栏目</el-button
        >
      </div>
      <div class="content">
        <el-table
          height="72vh"
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="column"
          style="width: 100%"
        >
          <el-table-column prop="cateId" label="#"> </el-table-column>
          <el-table-column prop="cateName" label="栏目名"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-link
                class="padR10"
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                >编辑</el-link
              >
              <el-popconfirm
                @confirm="delBut(scope.row)"
                title="删除后无法找回，是否确定？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >删除</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增与编辑 -->
    <div class="dialog">
      <el-dialog
        :modal-append-to-body="false"
        :visible.sync="dialogColumn"
        width="50%"
        :dialogAdminClose="true"
        @close="dialogAdminClose"
      >
        <span slot="title">
          <span class="header-main-title">{{ dialogTitle }}</span>
        </span>
        <div class="ColumnForm textalignLeft">
          <el-form
            :rules="rules"
            size="small"
            ref="ColumnForm"
            :model="ColumnForm"
            label-width="80px"
          >
            <el-form-item label="栏目名" prop="cateName">
              <el-input v-model="ColumnForm.cateName"></el-input>
            </el-form-item>
            <el-form-item label="图片" prop="imageUrl">
              <div class="image">
                <el-upload
                  action="#"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :file-list="fileList"
                  :on-remove="handleRemove"
                  :limit="1"
                  :http-request="uploadSectionFile"
                  :on-exceed="handleExceed">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogColumn = false">取 消</el-button>
          <el-button type="primary" @click="dialogColumnBut('ColumnForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  apiGetCategorys,
  apiDelCategorys,
  apiAddCategorys,
  apiEditCategorys
} from '@/api/articleManage'
import { apiUploadByBase64 } from '@/api/uploading'
let _self
export default {
  name: '',
  props: [''],
  data() {
    return {
      column: [], // 列表
      ColumnForm: {
        cateName: '',
        imageUrl: '',
        cateType: '0' // 当前业务固定为0
      },
      editRow: '', // 栏目列表数据
      fileList: [], // 编辑时将图片显示
      rules: {
        cateName: [
          { required: true, message: '请输入栏目名', trigger: 'blur' }
        ],
        imageUrl: [
          { required: true, message: '请添加栏目图片', trigger: 'blur' }
        ]
      },
      dialogTitle: '',
      dialogColumn: false
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    _self = this
    this.GetCategorys()
  },

  methods: {
    // 列表-确认
    confirmBut(row) {
      console.log(row)
    },
    // 添加栏目
    addColumnBut() {
      this.dialogTitle = '新增栏目'
      this.dialogColumn = true
    },
    // 编辑
    editBut(row) {
      this.ColumnForm.cateName = row.cateName
      this.ColumnForm.imageUrl = row.catePic
      this.fileList = [{ url: this.baseImage + row.catePic }]
      this.editRow = row
      this.dialogColumn = true
    },
    // 删除栏目
    delBut(row) {
      apiDelCategorys({
        cateId: row.cateId
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.GetCategorys()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },
    dialogAdminClose() {
      this.ColumnForm = {
        cateName: '',
        imageUrl: '',
        cateType: '0' // 当前业务固定为0
      }
      this.editRow = ''
      this.fileList = []
    },
    // 弹窗确定
    dialogColumnBut(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 不为空走编辑
          if (this.editRow !== '') {
            apiEditCategorys({
              cateId: this.editRow.cateId,
              cateName: this.ColumnForm.cateName,
              catePic: this.ColumnForm.imageUrl,
              cateType: this.ColumnForm.cateType
            }).then(res => {
              if (res.status === 0) {
                this.$Ms(res.msg)
                this.formShop = {
                  name: '',
                  unitName: '',
                  stock: '',
                  price: '',
                  dtl: '',
                  imageUpload: ''
                }
                this.GetCategorys()
                this.fileList = []
              } else if (res.status === 1) {
                this.$Me(res.msg)
              }
              this.dialogColumn = false
            })
          } else {
            apiAddCategorys({
              cateName: this.ColumnForm.cateName,
              catePic: this.ColumnForm.imageUrl,
              cateType: this.ColumnForm.cateType
            }).then(res => {
              if (res.status === 0) {
                this.$Ms(res.msg)
                this.ColumnForm = {
                  cateName: '',
                  imageUrl: '',
                  cateType: '0'
                }
                this.fileList = []
                this.GetCategorys()
                this.dialogColumn = false
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /**
     * 文件上传-自定义上传行为
     * */
    uploadSectionFile(params, file1) {
      if (_self.fileList.length > 0) {
        this.$message.error('最高可上传一个图片')
        return
      }
      console.log(params)
      console.log(file1)
      const file = params.file
      const fileType = file.type
      const isImage = fileType.indexOf('image') !== -1
      console.log(file)
      const isLt2M = file.size / 1024 / 1024 < 2
      // 这里常规检验，看项目需求而定
      if (!isImage) {
        this.$message.error('只能上传图片格式png、jpg、gif!')
        return
      }
      if (!isLt2M) {
        this.$message.error('只能上传图片大小小于2M')
        return
      }
      // 将图片转成base64
      const reader = new FileReader()
      reader.readAsDataURL(file) // 开始转
      reader.onload = function(e) {
        // const _self = this
        // this.result // 这个就是base64编码了
        let imageUrl = this.result.split('base64,')[1]
        apiUploadByBase64({
          base64: imageUrl,
          path: 'BackstageCategorys'
        }).then(res => {
          if (res.status === 0) {
            _self.$message({
              message: '图片上传成功',
              type: 'success'
            })
            _self.ColumnForm.imageUrl = res.data
            _self.fileList[0] = res.data
          }
        })
      }
    },
    // 删除文件之前的钩子
    handleRemove() {
      _self.fileList = []
    },
    // 文件超出个数限制时的钩
    handleExceed() {
      this.$message.error('最高可上传一个图片')
    },
    // 接口
    // 获取栏目列表
    GetCategorys() {
      apiGetCategorys().then(res => {
        if (res.status === 0) {
          this.column = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
